import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _subscribeRequest = {};
var _subscribeResponse = {};
var _unsubscribeRequest = {};
var _unsubscribeResponse = {};
function resolveComWixpressEcomContactsEmailSubscriberContactsEmailSubscriberUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/contacts-email-subscriber',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_/v1/subscribe',
                destPath: '/v1/subscribe',
            },
            {
                srcPath: '/_/v1/unsubscribe',
                destPath: '/v1/unsubscribe',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function subscribe(payload) {
    var _a = serializer(_subscribeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_subscribeResponse, {}).fromJSON;
    function __subscribe(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.subscribe_request',
            method: 'GET',
            methodFqn: 'com.wixpress.ecom.contacts.email.subscriber.ContactsEmailSubscriber.Subscribe',
            url: resolveComWixpressEcomContactsEmailSubscriberContactsEmailSubscriberUrl({ protoPath: '/v1/subscribe', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __subscribe.fromReq = fromReq;
    __subscribe.__isAmbassador = true;
    return __subscribe;
}
export function unsubscribe(payload) {
    var _a = serializer(_unsubscribeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unsubscribeResponse, {}).fromJSON;
    function __unsubscribe(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.subscribe_request',
            method: 'GET',
            methodFqn: 'com.wixpress.ecom.contacts.email.subscriber.ContactsEmailSubscriber.Unsubscribe',
            url: resolveComWixpressEcomContactsEmailSubscriberContactsEmailSubscriberUrl({ protoPath: '/v1/unsubscribe', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unsubscribe.fromReq = fromReq;
    __unsubscribe.__isAmbassador = true;
    return __unsubscribe;
}
//# sourceMappingURL=http.impl.js.map